import { type IndividualProduct } from "@lib/products";
import { type CSSProperties } from "react";

type SelectedShadeProps = {
  shade: IndividualProduct | null;
  out_of_stock_message: string;
  style: CSSProperties;
};
export function SelectedShade({
  shade,
  out_of_stock_message,
  style,
}: SelectedShadeProps) {
  return (
    <div className="mb-4 relative" style={{ ...style } as CSSProperties}>
      {shade ? (
        <>
          <img
            src={shade.image}
            width="800"
            height="800"
            alt={shade.name}
            className="w-full object-cover block"
          />
          <span
            className={`pt-4 text-center grid-cols-1 grid-rows-1 gap-2 items-center justify-center ${!shade?.hasStock ? "flex" : "grid"}`}
          >
            <span
              style={{ fontStyle: "var(--shade-title-font-style)" }}
              className="row-start-1 col-start-1 truncate text-[--color] font-[family-name:--shade-title-font-name] font-[--shade-title-font-weight]"
            >
              {shade.name}
            </span>
            <span
              aria-hidden={shade.hasStock}
              className={`bg-black text-white col-start-1 row-start-1 text-[12px] opacity-0 py-1 px-2 rounded-sm whitespace-nowrap flex-shrink-0 ${!shade.hasStock ? "opacity-100 w-auto " : ""}`}
            >
              {out_of_stock_message}
            </span>
          </span>
        </>
      ) : (
        <span className="bg-slate-100 aspect-square block w-full"></span>
      )}
    </div>
  );
}
